/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardrecorded2Inputs */

const en_toolcardrecorded2 = /** @type {(inputs: Toolcardrecorded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ recorded`)
};

const pt_toolcardrecorded2 = /** @type {(inputs: Toolcardrecorded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ registado`)
};

/**
* | output |
* | --- |
* | "✓ recorded" |
*
* @param {Toolcardrecorded2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardrecorded2 = /** @type {((inputs?: Toolcardrecorded2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardrecorded2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardrecorded2(inputs)
	return pt_toolcardrecorded2(inputs)
});
export { toolcardrecorded2 as "toolCardRecorded" }